import React from 'react';
import principlesBg from '../../../assets/site/bg-process.jpg';
import HomeSectionLink from '../../site/components/HomeSectionLink';
import Section from '../../site/components/Section';
import SectionHead from '../../site/components/SectionHead';
import cx from '../../site/utils/cx';
import ui from '../../site/styles/primitives.module.css';
import { principles, whyPartner } from '../aboutContent';
import PillarGrid from '../components/PillarGrid';
import styles from './Principles.module.css';

const Principles = () => (
  <Section id="principles" background={principlesBg} backgroundPosition="center 45%">
    <div className={ui.wrap}>
      <SectionHead eyebrow="How we work" title="Principles behind" highlight="every investment" lede={whyPartner} />
      <PillarGrid items={principles} />
      <div className={styles.tagband} data-reveal="">
        <strong>Building Wealth. Rebuilding Cities.</strong>
        <HomeSectionLink hash="#invest" className={cx(ui.btn, ui.btnPrimary)}>
          Explore opportunities
        </HomeSectionLink>
      </div>
    </div>
  </Section>
);

export default Principles;
